import React from 'react';
import '../order-approval-tabs.css';

export const TabContextTitle = ({ label, badge }: { label: string; badge?: string }) => {
  return (
    <div className="tab-context-title">
      {badge && <span className="tab-context-badge">{badge}</span>}
      <h5 className="tab-context-label">{label}</h5>
    </div>
  );
};
